'use strict';/* global define:false */define('modules/users/services/user-cache/index',['angular'],function(ng){'use strict';
     service.$inject = ["Users", "Me"];var validAccessors=['getAll','getInspectable','getSupervisees'];function getAccessor(all){if(validAccessors.indexOf(all)!==-1){return all;}return'getAll';}function now(){return+new Date();}// @ngInject
function service(Users,Me){// jshint validthis:true
// jshint latedef:false
// cache
var cache={};// last updates
var chronos={};// API decides caching time
var lifetime=Me.get().organization.refreshTimeouts.user;this.get=get;// ---
function get(accessor,options){accessor=getAccessor(accessor);if(!cache[accessor]){// no cache yet - fetch
cache[accessor]=fetch(accessor,options);}else if(now()-chronos[accessor]>lifetime){// cache outdated - fetch
fetch(accessor,options).$promise.then(function(users){ng.extend(cache[accessor],users);});}return cache[accessor];}/**
     * Fetch data for given accessor
     *
     * @param  {String} accessor - Accessor describing
     * @param  {[type]} options  [description]
     * @return {[type]}          [description]
     */function fetch(accessor,options){var resource=Users[accessor](options);resource.$promise.then(function(){chronos[accessor]=now();});return resource;}}return service;});
